import { render, staticRenderFns } from "./ImageUseConsentModal.vue?vue&type=template&id=9567134e&scoped=true"
import script from "./ImageUseConsentModal.vue?vue&type=script&lang=js"
export * from "./ImageUseConsentModal.vue?vue&type=script&lang=js"
import style0 from "./ImageUseConsentModal.vue?vue&type=style&index=0&id=9567134e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9567134e",
  null
  
)

export default component.exports